import { Box, Typography, Container } from '@mui/material';
import { styled } from '@mui/system';
import { theme, typeOfReadingMap, mapBackendKeyToStateKey } from '../../lib/index';

import time from '../../assets/images/time-icon.svg';
import price from '../../assets/images/price-icon.svg';

import BuyButton from './BuyButton';

function Offers({ offersData }) {
  if (!offersData.offers) {
    return null;
  }

  return (
    <Wrapper>
      <Typography variant="h2" sx={{ marginBottom: '20px' }}>
        Angebote
      </Typography>
      <OffersBox>
        {
            offersData.offers
              .filter((offer) => mapBackendKeyToStateKey(offer.reader_offers_type, typeOfReadingMap) !== 'unknown')
              .map((offer, index) => (
                <Box key={index} className="offer">
                  <Box className="offer__text">
                    <Box className="offer__text__headline">
                      <Typography
                        variant="h3"
                        className="offer__text__headline__title"
                      >
                        {mapBackendKeyToStateKey(
                          offer.reader_offers_type,
                          typeOfReadingMap
                        )}
                      </Typography>
                      <Box className="offer__text__headline__inner">
                        <img src={time} alt="duration" />
                        <Typography>
                          {offer.reader_offers_duration}
                          {' '}
                          min
                        </Typography>
                      </Box>
                      <Box className="offer__text__headline__inner">
                        <img src={price} alt="price" />
                        <Typography>
                          {offer.reader_offers_price}
                          {' '}
                          €
                        </Typography>
                      </Box>
                    </Box>
                    <Box className="offer__text__body">
                      <Typography>
                        {offer.reader_offers_content}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              ))
          }
        { offersData.shopifyId !== '' && <BuyButton shopifyId={offersData.shopifyId} /> }
      </OffersBox>
    </Wrapper>
  );
}

export default Offers;

// Styling
const Wrapper = styled(
  Container,
  {}
)({
  padding: 0,
});

const OffersBox = styled(
  Box,
  {}
)({
  margin: '0 auto',
  padding: 0,

  '& .offer': {
    display: 'flex',
    marginBottom: 30,
    padding: 20,

    overflow: 'hidden',
    maxWidth: '100%',
    height: 'fit-content',
    minHeight: 130,
    borderRadius: '0 30px',

    flexDirection: 'column',

    background: theme.palette.newPrimary,

    [theme.breakpoints.up('laptop')]: {
      marginBottom: 50,
      padding: 0,

      flexDirection: 'row',
    },

    '&__image': {
      display: 'flex',
      marginBottom: 20,

      gap: 30,

      [theme.breakpoints.up('laptop')]: {
        marginBottom: 0,
        display: 'block',
      },

      '& img': {
        objectFit: 'cover',
        width: 100,
        minWidth: 100,
        borderRadius: '0 15px',

        [theme.breakpoints.up('laptop')]: {
          width: 250,
          height: '100%',
          borderRadius: '0 30px',
        },
      },

      '&__headline': {
        // not visible on desktop device
        display: 'flex',
        width: '100%',

        flexDirection: 'column',
        justifyContent: 'center',

        [theme.breakpoints.up('laptop')]: {
          display: 'none',
        },

        '&__title': {
          lineHeight: '1',
          textTransform: 'uppercase',
          marginBottom: 20,

          [theme.breakpoints.up('laptop')]: {
            marginRight: 50,
            width: 300,

            lineHeight: '1.5',
          },
        },

        '&__inner': {
          display: 'flex',
          marginRight: 20,

          alignItems: 'center',
          gap: 10,

          [theme.breakpoints.up('laptop')]: {
            width: 200,
          },

          '& img': {
            width: 16,
            minWidth: 'unset',
            height: 16,
            minHeight: 'unset',
            borderRadius: 0,
          },

          '& .MuiTypography-root': {
            ...theme.typography.p16,

            [theme.breakpoints.up('laptop')]: {
              ...theme.typography.pBold17,
            },
          },
        },
      },
    },

    '&__text': {
      flexGrow: 1,
      padding: 0,

      [theme.breakpoints.up('laptop')]: {
        padding: '40px 50px',
        width: '70%',
      },

      '&__headline': {
        // not visible on mobile device
        display: 'none',
        paddingBottom: 30,
        width: '100%',

        [theme.breakpoints.up('laptop')]: {
          display: 'flex',
        },

        '&__title': {
          marginRight: 50,
          width: 300,

          textTransform: 'uppercase',
        },

        '&__inner': {
          display: 'flex',
          marginRight: 20,
          width: 200,

          alignItems: 'center',
          gap: 10,

          '& .MuiTypography-root': {
            ...theme.typography.pBold17,
          },
        },
      },

      '&__body .MuiTypography-root': {
        ...theme.typography.pSmall,

        whiteSpace: 'pre-wrap',

        [theme.breakpoints.up('laptop')]: {
          ...theme.typography.p16,

          paddingRight: 50,
        },
      },
    },
  },
});
